import clsx from 'clsx'
import React, { FC, useCallback, useEffect, useState } from 'react'

import styles from './progressbar.module.scss'

export interface ProgressBarProps {
  className?: string
  progressColor?: string
  trackColor?: string
  width: string | number
  withMarginTop?: boolean
}

export const ProgressBar: FC<ProgressBarProps> = ({
  className,
  progressColor,
  trackColor,
  width,
  withMarginTop = true,
}) => {
  const [inViewport, setInViewport] = useState<boolean>(false)
  const observerRef = React.useRef<IntersectionObserver | null>(null)
  const call = useCallback((element) => {
    if (!observerRef.current) {
      const observer = new IntersectionObserver(([entry]) => {
        setInViewport(entry.isIntersecting)
      })
      observerRef.current = observer
    }
    if (!element) {
      return
    }
    observerRef.current!.observe(element)
  }, [])

  // warning only dismount!
  useEffect(() => () => {
    if (observerRef.current) {
      observerRef.current?.disconnect()
    }
  }, [observerRef])

  return (
    <div
      className={clsx(
        styles.progressBar,
        'progressBarWrapper',
        className,
        withMarginTop && styles.topProgress,
      )}
      ref={call}
      style={{ background: trackColor }}
    >
      <div
        className={clsx(styles.progressBarContent, 'progressBarContent')}
        style={{
          width: `${inViewport ? width : 100}%`,
          background: progressColor,
        }}
      />
    </div>
  )
}

